<template>
  <div class="el-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ElButtonGroup'
  };
</script>



// WEBPACK FOOTER //
// packages/button/src/button-group.vue